import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Emptyview from "../views/Emptyview.vue";
import Cookies from "js-cookie";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/emptyview",
    name: "Emptyview",
    component: Emptyview,
    meta: { requiresAuth: false },
  },
  {
    path: "/zsplus_auth",
    name: "zsplus_auth",
    component: () => import("@/views/ZsplusAuth.vue"),
  },
  {
    path: "/wx_auth",
    name: "wx_auth",
    component: () => import("@/views/WechatAuth.vue"),
    meta: {
      index: 1,
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
const trackKit = window.trackKit;
// 初始化埋点
trackKit.init({
  pageKey: "zsplus_topic",
  vueRouter: router,
});

router.beforeEach((to, from, next) => {
  const userAgentString = navigator.userAgent.toLowerCase();
  // if (userAgentString.indexOf("zsrbapp") >= 0) {
  //   // 校验中山+存储的授权信息
  //   const sessionToken = sessionStorage.getItem("sessionToken");
  //   if (!sessionToken && to.name !== "zsplus_auth") {
  //     sessionStorage.setItem("zsplusRedirectUrl", to.fullPath);
  //     next({
  //       name: "zsplus_auth",
  //     });
  //   } else {
  //     next();
  //   }
  // } else
  if (userAgentString.indexOf("micromessenger") >= 0) {
    // 微信授权页路径（空白页）
    if (to.path === "/wx_auth") {
      next();
      return;
    }
    // 校验微信授权时存储的微信授权信息
    // const wxInfo = sessionStorage.getItem("wxInfo");
    const token = Cookies.get("token");
    // const token = "3a91b42f-93b3-4534-82d3-9be74816a4ba";
    // 没有用户信息（即未进行微信授权）
    if (!token) {
      console.log("into getauth");
      // 存储默认打开时访问的页面路径

      // 微信授权获取用户信息指定的路径
      let redirect_uri = "";
      if (to.fullPath) {
        redirect_uri = encodeURIComponent(
          `https://zsrbapp.zsnews.cn/mobile/single_topic/?redirect_path=${to.fullPath}#/wx_auth`
        );
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2d1b0208e6e6741f&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&connect_redirect=1#wechat_redirect`;
      } else {
        redirect_uri = encodeURIComponent(
          `https://zsrbapp.zsnews.cn/mobile/single_topic/#/wx_auth`
        );
      }
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2d1b0208e6e6741f&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&connect_redirect=1#wechat_redirect`;
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
